import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, AppText, styled } from '@streem/ui-react';
import { forwardRef, useRef } from 'react';
import { RequeueButton } from './requeue_button';
import { useTradeRow } from '../../../../../hooks/use_trade_row';
export const Menu = forwardRef(function CallTransferMenuComponent({ trades, onRequeueTrade, showYn }, ref) {
    return (_jsxs(Container, { showYn: showYn, ref: ref, children: [_jsx(HeaderRowContainer, { children: "Transfer Call" }), trades.map(({ name, disableTransfer }) => (_jsx(TradeRow, { name: name, disabled: disableTransfer, onRequeueTrade: onRequeueTrade }, name)))] }));
});
function TradeRow({ name, disabled, onRequeueTrade }) {
    const tradeMenuButtonRef = useRef(null);
    const requeueButtonRef = useRef(null);
    const { color, showPopup, requeueTrade, onClick } = useTradeRow(name, disabled, onRequeueTrade, tradeMenuButtonRef, requeueButtonRef);
    return (_jsxs(TradeRowContainer, { children: [_jsxs(Button, { onClick: onClick, disabled: disabled, "data-testid": `call-transfer-menu-trade-menu-button-${name}`, ref: tradeMenuButtonRef, children: [_jsx(AppText, { size: "medium", color: color, children: name }), _jsx(AppIcon, { name: "OpenCaretIcon", color: color, size: "small" })] }), _jsx(RequeueButton, { name: name, onRequeueTrade: requeueTrade, showYn: showPopup, tradeMenuButtonRef: tradeMenuButtonRef, ref: requeueButtonRef })] }));
}
const HeaderRowContainer = styled.div(({ theme }) => ({
    paddingLeft: '.75rem',
    paddingRight: '.75rem',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.text.headingFontFamily,
    fontSize: theme.text.size.medium,
    lineHeight: theme.text.lineHeight.medium,
    fontWeight: 500,
    height: '3.5rem',
    borderBottom: `1px ${theme.colors.grey10} solid`,
}));
const TradeRowContainer = styled.div(({ theme }) => ({
    // the next 3 values will default trade rows to 4rem, but allow them to shrink
    //     if there is not enough space (it will not allow them to grow)
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
    height: '4rem',
    minHeight: '1.75rem',
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    ':not(:last-child)': {
        borderBottom: `1px ${theme.colors.grey10} solid`,
    },
}));
const Button = styled.button(({ theme, disabled }) => ({
    display: 'flex',
    minWidth: '13.625rem',
    width: '100%',
    paddingLeft: '1.5rem',
    paddingRight: '.75rem',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '0',
    backgroundColor: 'transparent',
    cursor: disabled ? 'not-allowed' : 'inhherit',
    ':hover': {
        backgroundColor: disabled ? 'inherit' : theme.colors.grey05,
    },
}));
const Container = styled.div(({ theme, showYn }) => ({
    boxShadow: theme.shadow.small,
    display: `${showYn ? 'inline-flex' : 'none'}`,
    flexDirection: 'column',
    flexWrap: 'nowrap',
    borderRadius: '0.5rem',
    backgroundColor: theme.colors.white,
    minWidth: '13.625rem',
    maxHeight: 'calc(100vh - 5rem)',
    position: 'absolute',
    bottom: 'calc(100% + .25rem)',
    right: '2.5rem',
    overflowY: 'auto',
}));
//# sourceMappingURL=menu.js.map